let config: Record<string, string | number> = {};

const prefix = 'VITE_';

for (const [key, value] of Object.entries(import.meta.env)) {
  if (!key.startsWith(prefix)) {
    continue;
  }
  const confKey = key.replace(prefix, '');
  config[confKey] = value as string | number;
}

config = {
  ...config,
  APP_VERSION: '1.24.4',
  APP_TITLE: 'Maverick Signings',
  // number of rows to show in nested lists before displaying a 'View more' button
  COLLAPSED_TBL_ROWS: 6,
  // refresh cookie is available in paths prefixed with this value
  // must match backend value
  AUTH_PATH_PREFIX: '/auth',
  // be urls
  API_BE_URL: config.API_URL + '/be',
  // oauth urls
  API_OA_URL: config.API_URL + '/oa',
  // number of digits required for a valid phone number
  PHONE_NR_OF_DIGITS: 10,
};

export default config;
